import React from "react";

/**
 * Custom SVG Icons from Figma Design
 * Source: https://www.figma.com/design/BIVtusLkqwoVKG5izJRYS5/Townhall-Agenda-Redesign?node-id=130-1229&m=dev
 */

export const CompanyMeetingIcon = ({
  size = 24,
  color = "#4C47CC",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 7C4 5.67392 4.52678 4.40215 5.46447 3.46447C6.40215 2.52678 7.67392 2 9 2H15C16.3261 2 17.5979 2.52678 18.5355 3.46447C19.4732 4.40215 20 5.67392 20 7V13C20 14.3261 19.4732 15.5979 18.5355 16.5355C17.5979 17.4732 16.3261 18 15 18H13V20H15C15.2652 20 15.5196 20.1054 15.7071 20.2929C15.8946 20.4804 16 20.7348 16 21C16 21.2652 15.8946 21.5196 15.7071 21.7071C15.5196 21.8946 15.2652 22 15 22H9C8.73478 22 8.48043 21.8946 8.29289 21.7071C8.10536 21.5196 8 21.2652 8 21C8 20.7348 8.10536 20.4804 8.29289 20.2929C8.48043 20.1054 8.73478 20 9 20H11V18H9C7.67392 18 6.40215 17.4732 5.46447 16.5355C4.52678 15.5979 4 14.3261 4 13V7ZM12 16H15C15.7956 16 16.5587 15.6839 17.1213 15.1213C17.6839 14.5587 18 13.7956 18 13H15C14.7348 13 14.4804 12.8946 14.2929 12.7071C14.1054 12.5196 14 12.2652 14 12C14 11.7348 14.1054 11.4804 14.2929 11.2929C14.4804 11.1054 14.7348 11 15 11H18V9H15C14.7348 9 14.4804 8.89464 14.2929 8.70711C14.1054 8.51957 14 8.26522 14 8C14 7.73478 14.1054 7.48043 14.2929 7.29289C14.4804 7.10536 14.7348 7 15 7H18C18 6.20435 17.6839 5.44129 17.1213 4.87868C16.5587 4.31607 15.7956 4 15 4H9C8.20435 4 7.44129 4.31607 6.87868 4.87868C6.31607 5.44129 6 6.20435 6 7H9C9.26522 7 9.51957 7.10536 9.70711 7.29289C9.89464 7.48043 10 7.73478 10 8C10 8.26522 9.89464 8.51957 9.70711 8.70711C9.51957 8.89464 9.26522 9 9 9H6V11H9C9.26522 11 9.51957 11.1054 9.70711 11.2929C9.89464 11.4804 10 11.7348 10 12C10 12.2652 9.89464 12.5196 9.70711 12.7071C9.51957 12.8946 9.26522 13 9 13H6C6 13.7956 6.31607 14.5587 6.87868 15.1213C7.44129 15.6839 8.20435 16 9 16H12Z"
      fill={color}
    />
  </svg>
);

export const TrainingClassIcon = ({
  size = 24,
  color = "#4C47CC",
  ...props
}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 20.0518H16.5M14.5 20.0518C13.6716 20.0518 13 19.3802 13 18.5518V16.0518H12.5M14.5 20.0518H10.5M12.5 16.0518H12V18.5518C12 19.3802 11.3284 20.0518 10.5 20.0518M12.5 16.0518V20.0518M10.5 20.0518H8.5"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5 2.05176H4.5C3.39543 2.05176 2.5 2.94719 2.5 4.05176V14.0518C2.5 15.1564 3.39543 16.0518 4.5 16.0518H20.5C21.6046 16.0518 22.5 15.1564 22.5 14.0518V4.05176C22.5 2.94719 21.6046 2.05176 20.5 2.05176Z"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 9.05176L10.5 6.05176V12.0518L15.5 9.05176Z"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const TeamMeetingIcon = ({ size = 24, color = "#4C47CC", ...props }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 13.5518H18.5"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M2.5 12.5518V11.6332C2.5 10.925 2.68803 10.2294 3.04488 9.61767L5.42118 5.54402C5.7796 4.92958 6.43741 4.55176 7.14874 4.55176H17.8513C18.5626 4.55176 19.2204 4.92958 19.5788 5.54402L21.9551 9.61767C22.312 10.2294 22.5 10.925 22.5 11.6332V12.5518"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.5 17.5518V12.5518C2.5 10.8949 3.84315 9.55176 5.5 9.55176H19.5C21.1569 9.55176 22.5 10.8949 22.5 12.5518V17.5518C22.5 19.2087 21.1569 20.5518 19.5 20.5518H16.4051C15.5148 20.5518 14.6704 20.1563 14.1005 19.4724L12.5 17.5518L10.8995 19.4724C10.3296 20.1563 9.48521 20.5518 8.59488 20.5518H5.5C3.84315 20.5518 2.5 19.2087 2.5 17.5518Z"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);

export const ClientCallIcon = ({ size = 24, color = "#4C47CC", ...props }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.0241 19.614C7.35783 20.024 6.5 19.5447 6.5 18.7623V6.34142C6.5 5.5591 7.35783 5.07975 8.0241 5.48977L18.1161 11.7002C18.7506 12.0907 18.7506 13.0131 18.1161 13.4036L8.0241 19.614Z"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);

export const PresentationUploadIcon = ({
  size = 24,
  color = "#4C47CC",
  ...props
}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 2.55176H18.5C19.6046 2.55176 20.5 3.44719 20.5 4.55176V15.5663L13.4986 22.5533H6.5C5.39543 22.5533 4.5 21.6579 4.5 20.5533V12.5518"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5 15.5518H15.5C14.3954 15.5518 13.5 16.4472 13.5 17.5518V22.5518"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 5.55176L7.5 2.55176L4.5 5.55176M7.5 10.5518V3.16054"
      stroke="#4C47CC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const FaithGatheringListIcon = ({
  size = 24,
  color = "#4C47CC",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.058 2.0798C11.9178 2.0198 11.7658 1.9926 11.6135 2.0003C11.4613 2.008 11.3128 2.0505 11.1794 2.1244C11.0461 2.1983 10.9314 2.3017 10.8441 2.4268C10.7569 2.5518 10.6994 2.6952 10.676 2.8458C10.6494 3.0741 10.5759 3.2944 10.46 3.4928C10.36 3.6578 10.21 3.8268 9.946 4.0728C9.426 4.5548 9.109 5.1318 9.024 5.7538C8.9499 6.3263 9.0643 6.9073 9.35 7.4088C9.842 8.2958 10.84 8.9998 11.903 8.9998C13.285 8.9998 15 8.0338 15 6.1938C15 5.2508 14.578 4.3648 14.054 3.6818C13.526 2.9948 12.811 2.4028 12.058 2.0808M11.306 5.5398C11.616 5.2528 11.918 4.9398 12.159 4.5498C12.267 4.6578 12.371 4.7748 12.468 4.9008C12.825 5.3668 13 5.8338 13 6.1948C13 6.3918 12.914 6.5708 12.72 6.7268C12.4853 6.9057 12.1981 7.002 11.903 7.0008C11.688 7.0008 11.3 6.8028 11.098 6.4388C11.0231 6.316 10.9905 6.172 11.005 6.0288C11.019 5.9208 11.078 5.7518 11.306 5.5398ZM9 9.9998C8.46957 9.9998 7.96086 10.2105 7.58579 10.5856C7.21071 10.9607 7 11.4694 7 11.9998V19.9998C7 20.5303 7.21071 21.039 7.58579 21.414C7.96086 21.7891 8.46957 21.9998 9 21.9998H15C15.5304 21.9998 16.0391 21.7891 16.4142 21.414C16.7893 21.039 17 20.5303 17 19.9998V11.9998C17 11.4694 16.7893 10.9607 16.4142 10.5856C16.0391 10.2105 15.5304 9.9998 15 9.9998H9ZM9 11.9998H15V19.9998H9V11.9998Z"
      fill={color}
    />
  </svg>
);

// Default fallback icon
export const DefaultMeetingIcon = ({
  size = 24,
  color = "#4C47CC",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="5" y="5" width="7" height="7" stroke={color} strokeWidth="1.5" />
    <rect x="16" y="5" width="7" height="7" stroke={color} strokeWidth="1.5" />
    <rect x="5" y="16" width="7" height="7" stroke={color} strokeWidth="1.5" />
    <rect x="16" y="16" width="7" height="7" stroke={color} strokeWidth="1.5" />
  </svg>
);

// Question mark icon for "Other" type
export const OtherMeetingIcon = ({
  size = 24,
  color = "#4C47CC",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="14" cy="14" r="10" stroke={color} strokeWidth="1.5" />
    <path
      d="M10.25 10.25a3.75 3.75 0 1 1 7.5 0c0 1.8-1.2 2.7-2.25 3.45-.75.54-1.5 1.05-1.5 2.05"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="14" cy="20" r="1" fill={color} />
  </svg>
);
